import React from "react";
import { Link} from "react-router-dom";
import SearchBar from "../../Components/Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import "./viewTeam.css";

const ViewTeamMember = () => {
  
  return (
    <div>
      <div
        style={{
          gap: "10px",
          display: "grid",
          gridTemplateColumns: "repeat(7, 1fr)",
          gridAutoRows: " auto",
        }}
      >
        <div style={{ gridColumn: "3/8", marginRight: "20px" }}>
          <SearchBar style={{ width: "max-content" }}></SearchBar>
        </div>
        <div
          className="back-icon"
          style={{
            gridColumn: "span 7",
            marginLeft: "20px",
            display: "flex",
            alignItems: "center",
          }}
        >
          <Link to="/team">
            <BackIcon style={{ cursor: "pointer" }} />
          </Link>
          <div>
            <h1>Team Members List</h1>
            <h4
              style={{
                position: "relative",
                top: "-10px",
                fontFamily: "Gilroy-Medium",
                fontSize: "14px",
                fontStyle: "normal",
                color: "black",
                fontWeight: "100",
                lineHeight: "10px",
                right: "-25px",
              }}
            >
              Builders/ Builders List/ View
            </h4>
          </div>
        </div>
        <div
          style={{
            margin: "0px 20px",
            borderRadius: "20px",
            background:
              "radial-gradient(4751.52% 100% at 100% 50%, #0D152B 28.65%, rgba(13, 21, 43, 0.70) 100%)",
            gridColumn: "1/8",
          }}
        >
          <div
            className="top-part"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(5,1fr)",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                gridColumn: "1/6",
              }}
            >
              <img
                src=""
                style={{ width: "100px", height: "100px", marginTop: "60px" }}
                alt=""
              />
              <div className="column">
                <div>
                  <span>Employee Name</span>
                  <h2>Test</h2>
                </div>
                <div>
                  <span>Employee Name</span>
                  <h2>Test</h2>
                </div>
              </div>
              <div className="column">
                <div>
                  <span>Employee Name</span>
                  <h2>Test</h2>
                </div>
                <div>
                  <span>Employee Name</span>
                  <h2>Test</h2>
                </div>
              </div>
              <div className="column">
                <div>
                  <span>Employee Name</span>
                  <h2>Test</h2>
                </div>
                <div>
                  <span>Employee Name</span>
                  <h2>Test</h2>
                </div>
              </div>
              <div className="column">
                <div>
                  <span>Employee Name</span>
                  <h2>Test</h2>
                </div>
                <div>
                  <span>Employee Name</span>
                  <h2>Test</h2>
                </div>
              </div>
            </div>
          </div>
          <div
            className="column"
            id="Address Details"
            style={{
              gridColumn: "span 7",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-around",
            }}
          >
            <div>
              <div>
                <div>
                  <span>Phone Number</span>
                  <h4>0074</h4>
                </div>
                <div>
                  <span>Phone Number</span>
                  <h4>0074</h4>
                </div>
              </div>
            </div>
            <div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
            </div>
            <div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
            </div>
            <div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
            </div>
            <div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
            </div>
            <div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
            </div>
          </div>
          <div
            className="column"
            style={{
              border: "1px solid #D1D1D1",
              margin: "42px 20px",
              borderRadius: "20px",
            }}
          >
            <h3 style={{ margin: "20px auto 20px 20px", color: "white" }}>
              Address Details
            </h3>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
            </div>
          </div>
          <div
            id="Document Details"
            className="column"
            style={{
              border: "1px solid #D1D1D1",
              margin: "42px 20px auto 20px",
              borderRadius: "20px",
              height:"20%"
            }}
          >
            <h3 style={{ margin: "20px auto 20px 20px", color: "white" }}>
              Documents Details
            </h3>
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              <div>
                <label className="label-image" htmlFor="image">Drag and Drop Files here</label>
                <input type="file" id="image" style={{ display: "none" }} />
              </div>
            </div>
          </div>
          <div
            id="Document Details"
            className="column"
            style={{
              border: "1px solid #D1D1D1",
              margin: "42px 20px auto 20px",
              borderRadius: "20px",
            }}
          >
            <h3
              style={{ marginLeft: "20px", marginTop: "20px", color: "white" }}
            >
              Bank Details
            </h3>
            <div
              style={{
                marginLeft: "20px",
                display: "flex",
                justifyContent: "center",
                gap: "10%",
              }}
            >
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
              <div>
                <span>Phone Number</span>
                <h4>0074</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewTeamMember;
